// What an opened Findings case showed beyond its row (components/CaseStory.jsx):
// its steps, how it ended, the walkthrough's notes and the names of who and
// what was involved, kept for the page's life so the list's search finds a
// case by any word it showed.
import { useSyncExternalStore } from "react";

const words = new Map();
const subscribers = new Set();
let version = 0;
const subscribe = (fn) => { subscribers.add(fn); return () => subscribers.delete(fn); };

/** Keeps what case `caseId` showed (strings), telling the search when it changed. */
export function setCaseWords(caseId, list) {
    const next = (list || []).filter(Boolean).join("\n");
    if (!caseId || words.get(caseId) === next) return;
    words.set(caseId, next);
    version += 1;
    for (const fn of subscribers) fn();
}

export function caseWordsOf(caseId) {
    return words.get(caseId) || "";
}

/** A number that changes whenever any case's words do. */
export function useCaseWordsVersion() {
    return useSyncExternalStore(subscribe, () => version, () => version);
}

export function _clearCaseWordsForTests() {
    words.clear();
    version += 1;
}
